// extracted by mini-css-extract-plugin
module.exports = {"superElipse":"super-ellipse-skins-xxlarge-superElipse-4f07d542","strokeWidth":"super-ellipse-skins-xxlarge-strokeWidth-763d4aa0"};